/* eslint-disable @typescript-eslint/no-empty-function */
import { FC } from 'react';
import { useSTKContext } from '@/context/context';
import { useModifierPriceDeviations } from '@/services/modifiers/modifiers.service';
import { PriceDeviationsDrawerShared } from '@/pages/Franchisee/SharedComponents/PriceDeviations/PriceDeviationsDrawerShared';
import { ModifierPriceDeviationsDrawerProps } from './ModifierPriceDeviationsDrawerProps.types';

export const ModifierPriceDeviationsDrawer: FC<ModifierPriceDeviationsDrawerProps> = ({
  isOpen,
  onClose,
  modifierCategory,
  modifierKeys,
  selectedGroupName,
  cameFromEditDrawer,
}) => {
  const { storesAndGroups } = useSTKContext();
  const selectedStores =
    storesAndGroups?.origin === 'tab-stores-groups'
      ? storesAndGroups.storeGroups?.find((item) => item.storeGroup === selectedGroupName)?.stores || []
      : storesAndGroups?.stores?.filter((item) => item.storeGroup === selectedGroupName).map((item) => item.storeNo) ||
        [];

  const { data: priceDeviations = [], isLoading } = useModifierPriceDeviations(
    true,
    modifierCategory,
    selectedStores,
    modifierKeys ?? [],
  );

  return (
    <PriceDeviationsDrawerShared
      isOpen={isOpen}
      onClose={onClose}
      selectedGroupName={selectedGroupName}
      data={priceDeviations}
      isLoading={isLoading}
      cameFromEditDrawer={cameFromEditDrawer}
    />
  );
};
